import {AgendaSearchParams} from '@/features/agenda/types'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {useCallback, useEffect, useMemo} from 'react'
import {useAgendaNavigation} from './useAgendaNavigation'

export const useAgendaSearchParams = () => {
    const {navigateToView} = useAgendaNavigation()
    const {searchParams, setSearchParams} = useParsedSearchParams(AgendaSearchParams, [
        'subjectIds',
        'specializationIds'
    ])

    const clearSearchParams = useCallback(() => {
        setSearchParams({
            subjectIds: undefined,
            specializationIds: undefined,
            category: undefined,
            patientId: undefined
        })
    }, [setSearchParams])

    const isSubjectSelected = useCallback(
        (subjectId: string) => {
            return searchParams.subjectIds?.includes(subjectId)
        },
        [searchParams.subjectIds]
    )

    const isPatientAgeRangeCategory = useMemo(() => {
        return (
            searchParams.category == 'evolutionary_age' ||
            searchParams.category == 'evolutionary_age_adults' ||
            searchParams.category == 'adults'
        )
    }, [searchParams.category])

    const isTeamCategory = useMemo(() => {
        return searchParams.category == 'team'
    }, [searchParams.category])

    const isCustomCategory = useMemo(() => {
        return searchParams.category == 'custom'
    }, [searchParams.category])

    useEffect(() => {
        if (
            (searchParams.subjectIds && searchParams.subjectIds.length > 1) ||
            (isTeamCategory && !searchParams.subjectIds) ||
            (isTeamCategory && searchParams.subjectIds && searchParams.subjectIds.length > 1)
        ) {
            navigateToView('day')
        }
    }, [searchParams.subjectIds, isTeamCategory, navigateToView])

    return {
        searchParams,
        setSearchParams,
        isSubjectSelected,
        isPatientAgeRangeCategory,
        isTeamCategory,
        isCustomCategory,
        clearSearchParams
    }
}
